import styled from "styled-components";

const ImageContent = styled.div`
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  width: 100%;
  height: 60%;
`;

export default ImageContent;
